import {Component, HostBinding, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {navigateToFeatureResource} from '@catfeatures/shared/utils';
import {SelectOption} from '@catuiform/types';
import {EntityForm} from '@catuimodels/shared/entity-form';
import {isNullOrUndefined} from 'util';
import {UpdateService} from "@catcore/services/update.service";
import {FeatureServicesService} from "@catmodels/feature-services/services/feature-services.service";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";

const componentBaseName = 'feature-evid-function-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-service-form',
  templateUrl: './feature-service-form.component.html',
})
export class FeatureServiceFormComponent extends EntityForm implements OnInit {
  @HostBinding('class') classNames = defaultClassNames;
  featureUnitOptions: SelectOption[];
  serviceName = null;

  labels = {
    name: 'Name',
    service: 'Service',
    units: 'Units',
  };

  get formIsReady() {
    let isReady = !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.featureUnitOptions);
    return isReady;
  }

  private feature: Feature;

  private currentResourceService;

  constructor(formBuilder: FormBuilder,
              private router: Router,
              private featureService: FeatureTypeService,
              private featureServiceService: FeatureServicesService,
              private genericService: GenericResourceService,
              private updateService: UpdateService) {
    super(formBuilder);

    this
      .featureService
      .getCurrent()
      .subscribe((feature: any) => {
        if (!isNullOrUndefined(feature)) {
          const units = this.featureService.extractConfigurableUnitsFor(feature);
          this.feature = feature;
          this.updateFeatureUnitOptions(units);
        }
      });
  }

  ngOnInit() {
  }

  onEntityReceived(entity) {
    this.currentResourceService = this.genericService.findServiceForResource(this.resourceUri);
  }

  refreshResource() {
    this.currentResourceService.refresh();
  }

  onUpdate() {
    this.updateService.update(
      () => this.featureServiceService.updateFromModel(this.formData.id),
      () => this.refreshResource(),
      'feature service');
  }

  protected afterUpdateForm() {
    const formData = this.getFormData();
    this.serviceName = formData._links.model.label;
  }

  protected afterDelete() {
    this.featureService.refreshCurrent();
    this.router.navigate(['features', this.feature.id, 'properties']);
  }

  private updateFeatureUnitOptions(linkedItems: any[]) {
    const optionList = [];
    linkedItems.forEach((item) => {
      optionList.push({label: item.label, value: item.href});
    });
    this.featureUnitOptions = optionList;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-services/components/feature-service-form/feature-service-form.component.ts